import type { TeamDTO, UserDTO } from '@copilot/shared';
import { api } from './client';
import type { InviteBody, UserPatch } from './types';

const enc = encodeURIComponent;

export const usersApi = {
  list: () => api<UserDTO[]>('/users'),
  invite: (body: InviteBody) => api<UserDTO>('/users/invite', { method: 'POST', body }),
  patch: (id: string, body: UserPatch) => api<UserDTO>(`/users/${enc(id)}`, { method: 'PATCH', body }),
  /** Clears the password and signs the user out everywhere; they sign up again with the same email. */
  resetPassword: (id: string) => api<UserDTO>(`/users/${enc(id)}/reset-password`, { method: 'POST' }),
};

export const teamsApi = {
  list: () => api<TeamDTO[]>('/teams'),
  create: (name: string) => api<TeamDTO>('/teams', { method: 'POST', body: { name } }),
  rename: (id: string, name: string) => api<TeamDTO>(`/teams/${enc(id)}`, { method: 'PATCH', body: { name } }),
  remove: (id: string) => api<void>(`/teams/${enc(id)}`, { method: 'DELETE' }),
};
